import { render, staticRenderFns } from "./fichaPaciente.vue?vue&type=template&id=2d0361c2&scoped=true"
import script from "./fichaPaciente.vue?vue&type=script&lang=js"
export * from "./fichaPaciente.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d0361c2",
  null
  
)

export default component.exports